import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/styles/reset.css";
import "./assets/styles/fonts.css";

ReactDOM.render(<App />, document.getElementById("root"));
